<template>
  <div class="e404">
    <div class="svg">
      <svg
        height="300"
        viewBox="0 0 512 512"
        width="300"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g fill="var(--shrink)">
            <path
              d="m480 172a19.994 19.994 0 0 0 -20-20h-20v112h20a19.994 19.994 0 0 0 20-20z"
            />
            <path d="m384 152h24v112h-24z" />
            <path
              d="m32 244a19.994 19.994 0 0 0 20 20h300v-112h-300a19.994 19.994 0 0 0 -20 20zm200-60a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24z"
            />
            <path d="m384 16h24v112h-24z" />
            <path
              d="m480 36a19.994 19.994 0 0 0 -20-20h-20v112h20a19.994 19.994 0 0 0 20-20z"
            />
            <path
              d="m32 36v72a19.994 19.994 0 0 0 20 20h300v-112h-300a19.994 19.994 0 0 0 -20 20zm200 12a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24z"
            />
            <path d="m384 288h24v112h-24z" />
            <path
              d="m460 288h-20v112h20a19.994 19.994 0 0 0 20-20v-72a19.994 19.994 0 0 0 -20-20z"
            />
            <path
              d="m32 380a19.994 19.994 0 0 0 20 20h300v-112h-300a19.994 19.994 0 0 0 -20 20zm200-60a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24zm-72 0a24 24 0 1 1 -24 24 24.006 24.006 0 0 1 24-24z"
            />
            <path d="m240 464h32v32h-32z" />
          </g>
          <g fill="var(--sub-color)">
            <path
              d="m120 208a32 32 0 1 0 -32 32 32.036 32.036 0 0 0 32-32zm-48 0a16 16 0 1 1 16 16 16.019 16.019 0 0 1 -16-16z"
            />
            <path
              d="m160 240a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
            />
            <path
              d="m232 240a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
            />
            <path
              d="m120 72a32 32 0 1 0 -32 32 32.036 32.036 0 0 0 32-32zm-48 0a16 16 0 1 1 16 16 16.019 16.019 0 0 1 -16-16z"
            />
            <path
              d="m160 104a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
            />
            <path
              d="m232 104a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
            />
            <path
              d="m88 312a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
            />
            <path
              d="m160 312a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
            />
            <path
              d="m264 344a32 32 0 1 0 -32 32 32.036 32.036 0 0 0 32-32zm-48 0a16 16 0 1 1 16 16 16.019 16.019 0 0 1 -16-16z"
            />
            <path
              d="m496 472h-216v-8a8 8 0 0 0 -8-8h-8v-24h16a8 8 0 0 0 8-8v-16h172a28.031 28.031 0 0 0 28-28v-72a28.031 28.031 0 0 0 -28-28h-20v-8h20a28.031 28.031 0 0 0 28-28v-72a28.031 28.031 0 0 0 -28-28h-20v-8h20a28.031 28.031 0 0 0 28-28v-72a28.031 28.031 0 0 0 -28-28h-408a28.031 28.031 0 0 0 -28 28v72a28.031 28.031 0 0 0 28 28h20v8h-20a28.031 28.031 0 0 0 -28 28v72a28.031 28.031 0 0 0 28 28h20v8h-20a28.031 28.031 0 0 0 -28 28v72a28.031 28.031 0 0 0 28 28h172v16a8 8 0 0 0 8 8h16v24h-8a8 8 0 0 0 -8 8v8h-216a8 8 0 0 0 0 16h216v8a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-8h216a8 8 0 0 0 0-16zm-48-176h12a12.01 12.01 0 0 1 12 12v72a12.01 12.01 0 0 1 -12 12h-12zm0-136h12a12.01 12.01 0 0 1 12 12v72a12.01 12.01 0 0 1 -12 12h-12zm0-136h12a12.01 12.01 0 0 1 12 12v72a12.01 12.01 0 0 1 -12 12h-12zm-72 368h-16v-96h16zm24 0h-8v-96h8zm-312-112v-8h336v8zm272-24v-96h16v96zm32 0v-96h8v96zm40 136h-16v-96h16zm0-136h-16v-96h16zm-16-232h16v96h-16zm-24 0h8v96h-8zm-32 0h16v96h-16zm64 112v8h-336v-8zm-372-16a12.01 12.01 0 0 1 -12-12v-72a12.01 12.01 0 0 1 12-12h292v96zm0 136a12.01 12.01 0 0 1 -12-12v-72a12.01 12.01 0 0 1 12-12h292v96zm0 136a12.01 12.01 0 0 1 -12-12v-72a12.01 12.01 0 0 1 12-12h292v96zm188 24v-8h32v8zm24 72h-16v-16h16z"
            />
          </g>
        </g>
      </svg>
    </div>
    <p>خطایی در سرور رخ داده</p>
    <a @click.prevent="reload" href="">بازنشانی صفحه</a>
  </div>
</template>
<script>
export default {
  methods: {
    reload() {
      location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.e404 {
  width: 100%;
  height: 100vh;
  background: var(--bg-color);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7897897897897897897;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h1 {
    font-size: 3em;
    // font-family: "lalezar";
    color: var(--sub-color);
    width: 200px;
    height: 200px;
    border-radius: 50%;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.185);
    background: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  p {
    margin-top: 1em;
    font-size: 1.5em;
    color: var(--sub-color);
    background: var(--main-color);
    padding: 0.25em 2em;
    border-radius: 5px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.178);
  }
  a {
    text-decoration: none;
    color: var(--main-color);
    background: var(--sub-color);
    padding: 0.25em 2em;
    border-radius: 5px;
    margin-top: 1em;
  }
  .svg {
    width: 300px;
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/errors/500.vue